<template>
  <!-- <div class="contentArea pt-0"> -->
    <div class="contentArea pt-0">
 
    
    <div class="row-12">
      <div class="col-12">
     
      <div v-if ="content.type==='content'">
          <Pagecontent />
      </div>  
      <div v-if="this.type==='banner'">
          <Pagebanner />
      </div>  
      


      
      </div>
    </div>

 
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import themeConfig from "./../../themeConfig";

import topButton from "./elements/topTableButton/topTableButton";

import Pagebanner from "../views/elements/banner/Banner.vue";
import Pagecontent from "../views/elements/content/Content_component.vue";

export default {
  data() {
    return {
      bermuda: themeConfig.theme.bermuda
    };
  },
  components: {
 
    Pagebanner,
    Pagecontent

    // horizontalCard,
    // board,
    // verticalCard

  },
  computed: {
    ...mapGetters({
      type: "general/type",
      content: "general/content",
      banner: "general/banner",
      language: "general/language",
    })
  },
  async mounted() {
    
    await this.$store.dispatch("general/get_content");
   
    // await this.$store.dispatch("general/page_banner");
    // await this.$store.dispatch("general/get_bannertype");
    // await this.$store.dispatch("general/get_language");
    // await this.$store.dispatch("general/get_banner");
    
    
    // this.$store.dispatch("general/getRenderDetail");
    // this.$store.dispatch("general/getTable", "detail");
    // this.$store.dispatch("general/page_content");
    

    // console.log("log render", this.componentDetail);
  }
};
</script>
<style lang="scss">
@import "../assets/scss/vuexy/_variables.scss";
.border_primary {
  border: 1px solid $primary;
}

.border_radius {
  border-radius: 6px;
}
</style>

<style lang="stylus">
.examplex
  display: flex;
  align-items: center;
  justify-content: center;
  button
    margin: 0px !important;
    &.btnx
      margin-left: 10px !important;
      border-radius: 5px 0px 0px 5px;
    &.btn-drop
      border-radius: 0px 5px 5px 0px;
      border-left: 1px solid rgba(255, 255, 255,.2);
</style>

<style lang="scss" scoped>

</style>
